import {
  Box,
  Button,
  Modal,
  Stack,
  Typography,
  Autocomplete,
  TextField,
} from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import style2 from "../../../styles/style2";
import { DivIcon } from "leaflet";
import { OpenStreetMapProvider } from "leaflet-geosearch";

const SelectMap = ({
  isModal,
  handleClick,
  text,
  setPosisi,
  disabled = false,
}) => {
  const [longtitude, setLongtitude] = useState(106.84365034035115);
  const [latitude, setLatitude] = useState(-6.242062883052782);
  const [markerDragged, setMarkerDragged] = useState(false);
  const markerRef = useRef(null);
  const mapProvider = new OpenStreetMapProvider();
  const [searchMapValue, setSearchMapValue] = useState("");
  const [searchMapSelected, setSearchMapSelected] = useState(null);
  const [searchMapDropdown, setSearchMapDropdown] = useState([]);

  useEffect(() => {
    if (text) {
      setLongtitude(text.features[0].geometry.coordinates[1]);
      setLatitude(text.features[0].geometry.coordinates[0]);
    }
  }, [text]);

  function SetViewOnClick({ coords }) {
    const map = useMap();
    map.setView(coords, map.getZoom());

    return null;
  }
  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        if (marker != null) {
          const { lat, lng } = marker.getLatLng();
          setLongtitude(lng);
          setLatitude(lat);
          setMarkerDragged(true);
        }
      },
    }),
    []
  );

  const popup = () => {
    if (markerDragged)
      return `New latitude: ${latitude}, new longitude: ${longtitude}`;
    return text ? text.query : "Location Default";
  };

  const icon = new DivIcon({
    className: "custom-div-icon",
    html: "<div style='background-color:#c30b82;' class='marker-pin'></div><i class='material-icons'><img src='https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png'></i>",
    iconSize: [30, 42],
    iconAnchor: [15, 42],
    popupAnchor: [-3, -42],
  });

  function LocationMarker() {
    return (
      <Marker
        position={[latitude, longtitude]}
        icon={icon}
        draggable={!disabled}
        ref={markerRef}
        eventHandlers={eventHandlers}
      >
        <Popup>
          <span>{popup()}</span>
        </Popup>
        <SetViewOnClick coords={[latitude, longtitude]} />
      </Marker>
    );
  }

  function passData() {
    handleClick();
    setPosisi({ lat: latitude, long: longtitude });
  }

  function keluar() {
    handleClick();
  }

  const handleSearchLocation = async (e, value, reason) => {
    if (reason == "clear" || value == null) {
      setSearchMapSelected(null);
      return;
    }
    if (reason == "select") {
      setSearchMapSelected(value);
      setLongtitude(value.x);
      setLatitude(value.y);
      setMarkerDragged(true);
    } else {
      setSearchMapValue(value);
      const results = await mapProvider.search({ query: value });
      setSearchMapDropdown(results);
    }
  };

  return (
    <Modal
      open={isModal}
      onClose={handleClick}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      overflow="scroll"
    >
      {longtitude !== null && latitude !== null && (
        <Box sx={style2} height="100%">
          <Box display="flex" alignItems="center" justifyContent="center">
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              justifyContent="center"
            >
              Titik Lokasi Kejadian
            </Typography>
            <br />
            <br />
          </Box>
          <Box display="flex" alignItems="center" justifyContent="center">
            <Box
              display="flex"
              justifyContent="center"
              backgroundColor="white"
              position="fixed"
              sx={{
                border: 3,
                p: 1,
                borderRadius: 3,
                borderColor: "lightgrey",
                position: "fixed",
                top: 70,
                zIndex: "tooltip",
              }}
              maxWidth="lg"
            >
              <Stack spacing={2} direction="row">
                <Button variant="contained" onClick={passData} color="success">
                  Ambil Lokasi
                </Button>
                <Button variant="contained" onClick={keluar} color="error">
                  Cancel
                </Button>
              </Stack>
            </Box>
          </Box>
          <Box display="flex" alignItems="center" justifyContent="center">
            <Box
              display="flex"
              justifyContent="center"
              backgroundColor="white"
              position="fixed"
              sx={{
                position: "fixed",
                top: 130,
                p: 1,
                borderRadius: 1,
                zIndex: "tooltip",
                width: "300px",
              }}
            >
              <Autocomplete
                name="searchLocation"
                fullWidth={true}
                // onChange={(e, value) => handleRegion(e, value)}
                // required
                // defaultValue={dataRegion.find(
                //   (item) => item.id === inputFields.idRegional
                // )}
                // getOptionLabel={(option) => option.name}
                options={searchMapDropdown}
                renderInput={(params) => (
                  <TextField {...params} label="Cari lokasi" />
                )}
                value={searchMapSelected}
                inputValue={searchMapValue}
                onInputChange={(e, value, reason) =>
                  handleSearchLocation(e, value, reason)
                }
                onChange={(e, value) =>
                  handleSearchLocation(e, value, "select")
                }
              />
            </Box>
          </Box>
          <MapContainer
            center={[-6.242062883052782, 106.84365034035115]}
            zoom={15}
            scrollWheelZoom={false}
            style={{ height: "90%" }}
            className="mapcontainer"
          >
            <TileLayer
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <LocationMarker />
          </MapContainer>
        </Box>
      )}
    </Modal>
  );
};

export default SelectMap;
